import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import { useEffect, useState } from 'react';
import { Button, Card, Modal, Spinner } from 'react-bootstrap';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ButtonCreate from 'utils/buttons/ButtonCreate';
import CreateMatriculadoModal from './modals/CreateMatriculadoModal';
import EditMatriculadoModal from './modals/EditMatriculadoModal';
import ListaMatriculados from './tables/MatriculadosTable';
import { getMatriculados } from 'redux/matriculadosSlice';
import { emptyAllRealEstateData } from 'redux/realEstateSlice';

const mapStateToProps = state => ({
  isLoading: state.matriculados.isLoading,
  matriculados: state.matriculados.data
});

const MatriculadosPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modalCreateShow, setModalCreateShow] = useState(false);
  const [switchNewUser, setSwitchNewUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [noRolesModal, setNoRolesModal] = useState(false);
  const editModalId = useSelector(state => state.matriculados.editModalId);
  const modalShow = editModalId !== null;

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getMatriculados({}, 0, 10, ''));
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    };

    fetchData();
  }, []);

  useEffect(() => {
    dispatch(emptyAllRealEstateData());
  }, []);

  return (
    <>
      <PageHeader
        title="Usuarios Matriculados"
        description="Gestiona los usuarios matriculados en tu inmobiliaria y sucursales."
        className="mb-3 bg-white"
      >
        <ButtonCreate
          text="Nuevo Matriculado"
          funcion={() => {
            setModalCreateShow(true);
          }}
          variant="primary"
        />
      </PageHeader>

      <Card className="bg-white">
        <Card.Header className="d-flex justify-content-between">
          <Card.Title className="fw-light d-flex align-items-center gap-2 ml-2">
            <span className="fs-0">
              <FontAwesomeIcon icon="fa-regular fa-user" />
            </span>

            <span>Listado de Usuarios Matriculados</span>
          </Card.Title>
        </Card.Header>

        <Card.Body>
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '200px'
              }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <ListaMatriculados
              switchNewUser={switchNewUser}
              setSwitchNewUser={setSwitchNewUser}
            />
          )}
        </Card.Body>
      </Card>

      <CreateMatriculadoModal
        modalShow={modalCreateShow}
        setModalShow={setModalCreateShow}
        switchNewUser={switchNewUser}
        setSwitchNewUser={setSwitchNewUser}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />

      <EditMatriculadoModal modalShow={modalShow} />

      <Modal show={noRolesModal} onHide={() => setNoRolesModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>No hay roles disponibles.</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="fs-1">
            Debes crear al menos un rol antes de poder crear usuarios
            matriculados.
          </p>

          <div className="d-flex justify-content-between">
            <Button variant="secondary" onClick={() => setNoRolesModal(false)}>
              Cerrar
            </Button>

            <Button
              variant="primary"
              onClick={() => navigate('/permisos/roles')}
            >
              Crear rol
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default connect(mapStateToProps)(MatriculadosPage);
